import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import { SiteHeader } from '@/components/site-header'
import { DownloadForm } from '@/components/downloads/download-form'
import { EGTA_BOARD_2025_CONTENT } from '@/content/downloads/egta-board-2025'
import { useTheme } from '@/components/theme-provider'

export default function EgtaBoard2025Page() {
  const { theme } = useTheme()
  
  // Set metadata and noindex
  useEffect(() => {
    document.title = EGTA_BOARD_2025_CONTENT.pageTitle

    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]')
    if (!metaDescription) {
      metaDescription = document.createElement('meta')
      metaDescription.setAttribute('name', 'description')
      document.head.appendChild(metaDescription)
    }
    metaDescription.setAttribute('content', EGTA_BOARD_2025_CONTENT.pageDescription)

    // Add noindex meta tag
    let metaRobots = document.querySelector('meta[name="robots"]')
    if (!metaRobots) {
      metaRobots = document.createElement('meta')
      metaRobots.setAttribute('name', 'robots')
      document.head.appendChild(metaRobots)
    }
    metaRobots.setAttribute('content', 'noindex, nofollow')

    // Cleanup on unmount
    return () => {
      if (metaRobots && metaRobots.parentNode) {
        metaRobots.parentNode.removeChild(metaRobots)
      }
    }
  }, [])

  // Determine which logo to show based on theme
  const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light'
  const currentTheme = theme === 'system' ? systemTheme : theme
  const logoSrc =
    currentTheme === 'dark'
      ? '/images/egta_logo_white.png'
      : '/images/egta_logo_standard.png'

  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <section className="relative py-16 md:py-24">
          <div className="container">
            <div className="mx-auto max-w-2xl">
              {/* Logo */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="mb-8 flex justify-center"
              >
                <img
                  src={logoSrc}
                  alt="EGTA Logo"
                  className="h-16 w-auto md:h-20"
                />
              </motion.div>

              {/* Header */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="mb-12 text-center"
              >
                <h1 className="mb-4 text-3xl font-bold md:text-4xl">
                  {EGTA_BOARD_2025_CONTENT.headerTitle}
                </h1>
                <p className="text-lg text-muted-foreground">
                  {EGTA_BOARD_2025_CONTENT.headerSubtitle}
                </p>
              </motion.div>

              {/* Form Card */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="rounded-lg border border-border bg-card p-6 shadow-lg md:p-8"
              >
                <DownloadForm
                  content={EGTA_BOARD_2025_CONTENT}
                  downloadType="egta-board-2025"
                />
              </motion.div>
            </div>
          </div>
        </section>
      </main>
    </div>
  )
}
